import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Users, Award, Zap, Shield } from 'lucide-react';
import { CTAButton } from './shared/CTAButton';
export function ProgramDetails() {
  return <section className="py-20 bg-[#F5E6E0]/30" data-id="element-170">
      <div className="max-w-6xl mx-auto px-4" data-id="element-171">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-172">
          <span className="text-[#9B2C5E] font-bold tracking-widest text-sm uppercase mb-2 block" data-id="element-173">
            Presentación
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A2E] mb-6" data-id="element-174">
            Programa Profesional{' '}
            <span className="text-[#9B2C5E] font-serif italic" data-id="element-175">
              Nails Artist Expert
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-176">
            Una formación 100% online diseñada para manicuristas que ya trabajan
            y quieren subir nivel de verdad.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20" data-id="element-177">
          {/* Left: What's included checklist */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-xl shadow-rose-900/5 border border-[#F5E6E0]" data-id="element-178">
            <h3 className="text-2xl font-bold mb-6 flex items-center gap-2" data-id="element-179">
              <Award className="text-[#C9A96E]" data-id="element-180" /> ¿Qué incluye tu acceso?
            </h3>
            <ul className="space-y-4" data-id="element-181">
              {[{
              text: '45 clases (100% online)',
              icon: <Zap className="w-5 h-5" data-id="element-182" />
            }, {
              text: 'Acceso de por vida + actualizaciones',
              icon: <Check className="w-5 h-5" data-id="element-183" />
            }, {
              text: 'Grupo Privado de Facebook (solo alumnas)',
              icon: <Users className="w-5 h-5" data-id="element-184" />
            }, {
              text: 'Certificado avalado por la instructora',
              icon: <Award className="w-5 h-5" data-id="element-185" />
            }, {
              text: 'Acceso inmediato por email',
              icon: <Zap className="w-5 h-5" data-id="element-186" />
            }, {
              text: 'Garantía 7 días',
              icon: <Shield className="w-5 h-5" data-id="element-187" />
            }].map((item, idx) => <li key={idx} className="flex items-center gap-3 p-3 rounded-lg hover:bg-[#FFF8F0] transition-colors" data-id="element-188">
                  <div className="text-[#9B2C5E] bg-[#F5E6E0] p-2 rounded-full" data-id="element-189">
                    {item.icon}
                  </div>
                  <span className="font-medium text-gray-800" data-id="element-190">{item.text}</span>
                </li>)}
            </ul>
            <div className="mt-8 pt-6 border-t border-gray-100" data-id="element-191">
              <div className="flex items-center justify-between" data-id="element-192">
                <span className="text-sm text-gray-500" data-id="element-193">
                  Pago seguro y verificado
                </span>
                <div className="flex gap-1" data-id="element-194">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-[#C9A96E] text-[#C9A96E]" data-id="element-195" />)}
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right: Results */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-196">
            <h3 className="text-3xl font-serif text-[#1A1A2E] mb-8" data-id="element-197">
              Lo que vas a lograr{' '}
              <span className="text-[#9B2C5E]" data-id="element-198">(en resultados reales)</span>
            </h3>

            <div className="space-y-6" data-id="element-199">
              {['Lograr cutículas más limpias con preparación correcta', 'Mejorar adherencia para reducir levantamientos', 'Construir mejor la estructura para sets más resistentes', 'Trabajar con torno/fresas con criterio para un acabado fino', 'Dominar sistemas y tendencias para ampliar tu carta', 'Sentirte más segura set tras set (y cobrar mejor)'].map((result, idx) => <div key={idx} className="flex gap-4" data-id="element-200">
                  <div className="mt-1 min-w-[24px] h-6 flex items-center justify-center bg-[#9B2C5E] rounded-full text-white" data-id="element-201">
                    <Check className="w-3 h-3" data-id="element-202" />
                  </div>
                  <p className="text-lg text-gray-700" data-id="element-203">{result}</p>
                </div>)}
            </div>

            <div className="mt-10 p-6 bg-[#9B2C5E]/5 rounded-xl border border-[#9B2C5E]/20" data-id="element-204">
              <p className="text-[#9B2C5E] font-bold text-center text-lg" data-id="element-205">
                Traducción real: menos retrabajo, más consistencia, más nivel.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Transformation Section */}
        <div className="bg-[#1A1A2E] rounded-3xl p-8 md:p-16 text-center" data-id="element-206">
          <h3 className="text-2xl md:text-3xl text-white font-serif mb-10" data-id="element-207">
            Después de esto, vas a dejar de…
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 text-left max-w-4xl mx-auto" data-id="element-208">
            {['Improvisar la preparación', 'Perder tiempo en limado excesivo', 'Vivir con miedo a desprendimientos', 'Sentir que tus sets son "lindos pero no premium"', 'Tardar tanto que regalás tu trabajo', 'Gastar producto de más', 'Dudar qué sistema usar', 'Sentirte insegura para subir precios'].map((item, idx) => <div key={idx} className="flex items-center gap-3 text-gray-300" data-id="element-209">
                <div className="w-1.5 h-1.5 bg-[#C9A96E] rounded-full" data-id="element-210" />
                <span data-id="element-211">{item}</span>
              </div>)}
          </div>
          <div className="mt-12" data-id="element-212">
            <CTAButton text="ACCEDER AHORA POR $29 USD" data-id="element-213" />
          </div>
        </div>
      </div>
    </section>;
}